import React, { useState, useEffect } from "react";

const ImageCarousel = ({ images }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [images]);

  if (!images || images.length === 0) return null;

  const prev = () => setIndex((index - 1 + images.length) % images.length);
  const next = () => setIndex((index + 1) % images.length);

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: "6px",
    overflow: "hidden",
    boxShadow: "0 0 4px rgba(0,0,0,0.1)"
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block"
  };

  const buttonStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.4)",
    color: "#fff",
    border: "none",
    fontSize: "1rem",
    padding: "2px 6px",
    cursor: "pointer",
    zIndex: 1
  };

  return (
    <div style={containerStyle}>
      <img src={images[index]} alt={`slide-${index}`} style={imageStyle} />
      {images.length > 1 && (
        <>
          <button onClick={prev} style={{ ...buttonStyle, left: "4px" }}>❮</button>
          <button onClick={next} style={{ ...buttonStyle, right: "4px" }}>❯</button>
        </>
      )}
    </div>
  );
};

export default ImageCarousel;
